import { CommonActions, NavigationContainerRefWithCurrent } from "@react-navigation/native";

type NavigatorType = NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>;

let _navigator: NavigatorType;

function setTopLevelNavigator(navigatorRef: NavigatorType) {
  _navigator = navigatorRef;
}

function navigate(routeName: string, params: any) {
  _navigator.dispatch(
    CommonActions.navigate({
      name: routeName,
      params,
    })
  );
}

export default {
  navigate,
  setTopLevelNavigator,
};
